// client/src/constants/licenseTypes.js
export const LicenseType = {
  UNKNOWN: 0,
  TRIAL: 1,
  NFR: 2,
  EDUCATIONAL: 3,
  SUBSCRIPTION: 4,
};

export const LicenseTypeLabels = {
  [LicenseType.UNKNOWN]: "Unknown",
  [LicenseType.TRIAL]: "Trial",
  [LicenseType.NFR]: "NFR",
  [LicenseType.EDUCATIONAL]: "Educational",
  [LicenseType.SUBSCRIPTION]: "Subscription",
};

// Helper function to get label by value
export const getLicenseTypeLabel = (type) => {
  return LicenseTypeLabels[type] || "Unknown";
};

// Helper function to validate license type
export const isValidLicenseType = (type) => {
  return Object.values(LicenseType).includes(type);
};
